import * as React from "react";
import styles = require("./style.less");

export default class CenteredLayout extends React.Component<any, any> {
    render() {
        return <div className={styles.container}>{this.props.children}</div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/CenteredLayout/CenteredLayout.tsx